/* eslint-disable import/prefer-default-export */
export function webAuthnSupported() {
  return window.navigator.credentials != null && window.PublicKeyCredential != null;
}
